module.exports = __webpack_public_path__ + "static/media/Matriz.8f39a264.jpg";